import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import DeliveryAreasOverview from "@widgets/deliveryAreas/overview/DeliveryAreasOverview";

const DeliveryAreas = () => {
    const route: Route = useMemo(() => router.deliveryAreas, []);

    return (
        <AdminLayout currentPage={route}>
            <DeliveryAreasOverview route={route}/>
        </AdminLayout>
    );
};

export default DeliveryAreas;